var Marionette = require('backbone.marionette');
var RelationType = require('../../models/relation-type-model');
var DboTypesCollection = require('../../collections/dbotypes-collection');

var RelationTypeForm = Marionette.View.extend({
    tagName: 'form',
    template: require('../../templates/relationtypes/relationtype-form.html'),
    model: new RelationType(),
    //collection: new DboTypesCollection(),

    modelEvents: {
        change: 'render'
    },

    ui: {
        name: '#name',
        description: '#description',
        parentType: '#parent-type',
        childType: '#child-type'
    },

    templateContext: function(){
        var that = this;
        return {
            items: that.collection.map(function(item) {
                return item.get("name");
            }),
            len: that.collection.length
        }
    },

    initialize: function(options){
        var that = this;
        _.bindAll(that, 'fillModel', 'clearModel');
        that.model.on('change', that.render, that);
        that.collection = options.dboTypes;
        /*that.collection.fetch({success: function() {
        }});*/
    },

    onRender: function() {
        this.$('#parent-type').selectize({
            allowEmptyOption: false
        });
        this.$('#child-type').selectize({
            allowEmptyOption: false
        });
    },

    fillModel: function(){
        var that = this;
        that.model.set({
            name: that.ui.name.val(),
            description: that.ui.description.val(),
            parentType: that.ui.parentType.val(),
            childType: that.ui.childType.val()
        }/*, {validate: true}*/);
        return this.model;
    },

    clearModel: function(){
        this.model.set(this.model.defaults);
        return this.model;
    }

});

module.exports = RelationTypeForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/relationtypes/relationtype-form-view.js
// module id = 429
// module chunks = 0